let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kfP21")).then(() => parcelRequire('fuuku'));